
/** @module toxi.THREE */
module.exports = {
	ToxiclibsSupport: require('./THREE/ToxiclibsSupport')
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/THREE.js
// module id = 4564
// module chunks = 13